import React, { useEffect, useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import {
    dateFormat,
    IntlMessageValue,
    UniButton,
    UniCards,
    UniForm,
    UniSpinner
} from '../../../../../../@WUM/core/Elements';
import { chatInterface } from "../../../API/request/chat.interface";
import { CryptEncrypt } from "../../../../../../@WUM/core/Elements/crypt/Crypt";
import { ApiRoot } from "../../../../../../@WUM/core/RestFullApi/api";

interface DetailCanvasProps {
    show: boolean;
    validated: boolean;
    handleClose: () => void;
    data?: chatInterface | undefined | boolean;
    Store: any;
    sendMessage: (
        from_uid: any,
        to_uid: any,
        group_id: any,
        messager: any,
        audio: any,
        image: any,
        type: any
    ) => void;
    setFetchData: React.Dispatch<React.SetStateAction<number>>;
}

export default function DetailCanvas({
                                         show,
                                         validated,
                                         handleClose,
                                         Store,
                                         data,
                                         sendMessage,
                                         setFetchData
                                     }: DetailCanvasProps): JSX.Element {

    console.log(data)
    if (typeof data !== 'object' || data === null) {
        return (
            <Offcanvas show={show} onHide={handleClose} placement={'end'}>
                <UniSpinner />
            </Offcanvas>
        );
    }

    const created_at = dateFormat(
        data.created_at,
        localStorage.getItem('locale'),
        'us',
        true,
        true,
        Store
    );

    const chats = data.chats as { date: string }[];

    const lastChatDate = chats.reduce((latestDate: string | null, chat: { date: string }) => {
        if (latestDate === null) {
            return chat.date;
        }

        return new Date(chat.date).getTime() > new Date(latestDate).getTime()
            ? chat.date
            : latestDate;
    }, null as string | null);

    const last_updated_at = lastChatDate
        ? dateFormat(
            lastChatDate,
            localStorage.getItem('locale'),
            'us',
            true,
            true,
            Store
        )
        : dateFormat(
            data.created_at,
            localStorage.getItem('locale'),
            'us',
            true,
            true,
            Store
        );

    const renderBadge = (subject: string) => {
        if (!subject) {
            return null;
        }

        const subjectMatch = subject.match(/^(\S+):(.*)$/);

        if (!subjectMatch) {
            return subject;
        }

        const badgeText = subjectMatch[1];

        return (
            <>
                <span className="badge bg-primary me-2 float-right">{badgeText}</span>
            </>
        );
    };

    const submitDetailMessage = (event: React.FormEvent<HTMLFormElement>): void => {
        event?.preventDefault();

        const form = event.currentTarget;
        const textarea = form.elements.namedItem('message') as HTMLTextAreaElement;

        const value = textarea.value.trim();

        if (value === '') {
            return;
        }


        const encryptedMessage = CryptEncrypt(value);

        const raw = JSON.stringify({
            id: 0,
            from_uid: Store.user.id,
            to_uid: '0',
            group_id: 0,
            messager: encryptedMessage,
            audio: '',
            image: '',
            media: localStorage.getItem('avatar'),
            date: new Date().toISOString(),
            type: 'msg',
            chat_ticket: data.id,
            username: localStorage.getItem('username'),
        });

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token') as string)
            },
            body: raw
        };

        sendMessage(
            Store.user.id,
            '0',
            0,
            encryptedMessage,
            '',
            '',
            'msg'
        );

        fetch(ApiRoot() + 'yoptimize/save/support/chat/messages/', requestOptions)
            .then((response) => response.text())
            .then(() => {
                setFetchData(Date.now());
                handleClose();
            })
            .catch((error) => console.log(error));
    };

    return (
        <Offcanvas show={show} onHide={handleClose} placement={'end'}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                    <div className={'fs-5 text-muted'}>
                        {IntlMessageValue('de', 'support.ticket.details.offcanvas.title', Store)}
                    </div>
                    <div>{data.subject}</div>
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <UniCards class={'mb-2'}>
                    <UniCards.Header>
                        <div className={"fw-bold"}>Übersicht</div>
                    </UniCards.Header>
                    <UniCards.Body class={""}>
                        <div>
                            <span>{IntlMessageValue('de', 'support.ticket.details.offcanvas.ticket.type', Store)}</span>
                            {renderBadge(data.subject)}
                            <hr />
                        <span className={'text-muted'}>
                            {IntlMessageValue('de', 'support.ticket.details.offcanvas.company', Store)}:{' '}
                        </span>
                        <span className={'float-right'}>
                            {data.company}
                        </span>
                        </div>
                        <hr className={"w-100"} />
                        <div>
                        <span className={'text-muted'}>
                            {IntlMessageValue('de', 'support.ticket.details.offcanvas.created_at', Store)}:{' '}
                        </span>
                            <span className={'float-right'}>
                            {created_at}
                        </span>

                        </div>
                        <hr className={"w-100"} />
                        <div>
                        <span className={'text-muted'}>
                            {IntlMessageValue('de', 'support.ticket.details.offcanvas.last_updated_at', Store)}:{' '}
                        </span>
                            <span className={'float-right'}>
                            {last_updated_at}
                        </span>
                        </div>
                    </UniCards.Body>


                </UniCards>

                <UniCards>
                    <UniCards.Header>
                        Schlussnachricht
                    </UniCards.Header>
                    <UniCards.Body>
                        <UniForm validated={validated} Submit={submitDetailMessage}>
                            <UniForm.FormGroup>
                                <UniForm.Label
                                    text={IntlMessageValue('de', 'support.ticket.offcanvas.message.label', Store)}
                                />
                                <UniForm.FormControl
                                    name={'message'}
                                    required={true}
                                    rows={7}
                                    as="textarea"
                                    defaultValue={IntlMessageValue("de","support.ticket.offcanvas.close.ticket.standard.message",Store)}
                                />
                                <UniForm.ControlFeedback
                                    text={IntlMessageValue('de', 'support.ticket.offcanvas.message.feedback', Store)}
                                />
                            </UniForm.FormGroup>

                            <UniButton type={'submit'}>
                                {IntlMessageValue('de', 'support.ticket.detail.offcanvas.submit', Store)}
                            </UniButton>
                        </UniForm>
                    </UniCards.Body>
                </UniCards>


            </Offcanvas.Body>
        </Offcanvas>
    );
}